import { Box } from '@deckee/deck-hand';
import styled from 'styled-components';

const CheckListItem = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grays[0]};
  &:last-of-type {
    border: none;
  }
`;

export default CheckListItem;
